
(function() {
  var result = { translations: { "pt-br": { "foundations-components": { "ActionsMenu": { "defaultAriaLabel": "A\xE7\xF5es" }, "tag": { "remove": "Remover tag" }, "Select": { "noResults": "Nenhum resultado encontrado", "searchPlaceholder": "Pesquisar...", "clearSelections": "Limpar sele\xE7\xE3o" }, "ErrorMessage": { "error": { "title": "Nem tudo est\xE1 perdido." }, "notFound": { "title": "Todos que vagueiam n\xE3o est\xE3o perdidos." }, "badRequest": { "title": "Houve um problema ao carregar essa p\xE1gina." }, "expired": { "title": "Desculpe." }, "sessionId": { "prefix": "ID da sess\xE3o: " } }, "ProgressSteps": { "completedStep": "Etapa conclu\xEDda", "incompleteStep": "Etapa n\xE3o conclu\xEDda" }, "Paginator": { "label": "Pagina\xE7\xE3o", "pageNumber": { "currentIndicator": "Voc\xEA est\xE1 atualmente em ", "description": "P\xE1gina " }, "firstPage": { "label": "Primeiro", "description": "Primeira p\xE1gina" }, "previousPage": { "label": "Voltar", "description": "P\xE1gina anterior" }, "nextPage": { "label": "Pr\xF3ximo", "description": "Pr\xF3xima p\xE1gina" }, "lastPage": { "label": "\xDAltimo", "description": "\xDAltima p\xE1gina" } }, "Datagrid": { "noData": { "Title": "Nenhum dado dispon\xEDvel", "Description": "N\xE3o h\xE1 dados dispon\xEDveis para exibir." }, "noResults": { "Title": "Nenhum resultado encontrado", "Description": "Tente ajustar a pesquisa e os filtros para encontrar o que voc\xEA procura.", "ClearActionLabel": "Limpar pesquisa e filtros" }, "toolbar": { "selectedRows": { "one": "{{count}} linha selecionada", "other": "{{count}} de linhas selecionadas", "clearSelection": "Limpar sele\xE7\xE3o", "selectAll": "Selecione todas as {{totalRows}} linhas" }, "search": { "placeholder": "Pesquisar", "label": "Pesquisar", "clearSearch": "Apagar pesquisa" } }, "pagination": { "visibleRows": "{{visibleRows}} de {{totalRows}} resultados", "itemsPerPage": "Itens por p\xE1gina", "countPerPage": { "one": "{{count}} por p\xE1gina", "other": "{{count}} por p\xE1gina", "many": "{{count}} por p\xE1gina" } }, "SkeletonGrid": { "loading": "Carregando" }, "DataGridColumnManagementPanel": { "description": "Escolha quais propriedades exibir como colunas. Em seguida, mova as propriedades para cima ou para baixo, ou arraste e solte, para alterar a ordem em que ser\xE3o exibidas.", "removeAllColumns": "Remover todas as colunas", "update": "Atualizar", "cancel": "Cancelar", "edit": "Editar colunas" } } }, "ui": { "UIAbstractPageSection": { "page": "Se\xE7\xE3o da p\xE1gina" }, "UICarousel": { "current": "Mostrando o item {{currentStepDisplayNumber}} de {{totalSteps}}", "prev": "Anterior", "next": "Pr\xF3ximo", "tip": "Use as setas para ver outros itens" }, "UIColorSwatch": { "label": "Seletor de cores {{value}}", "noColorLabel": "Seletor de cores; nenhuma cor foi selecionada." }, "UIButtonCollapser": { "dropdownLabel": "A\xE7\xF5es" }, "UIErrorMessage": { "error": { "title": "Nem tudo est\xE1 perdido." }, "notFound": { "title": "Todos que vagueiam n\xE3o est\xE3o perdidos." }, "badRequest": { "title": "Houve um problema ao carregar essa p\xE1gina." }, "expired": { "title": "Desculpe." } }, "UIPanelNavigator": { "backButton": "Ir para a tela anterior" }, "UILoadingSpinner": { "busyText": "Carregando", "completedText": "Carregado" }, "UISideNav": { "navigationLandmark": "Secund\xE1rio" }, "UISortTH": { "ascendingSort": "Classifica\xE7\xE3o em ordem crescente. Pressione para classificar em ordem decrescente.", "descendingSort": "Classifica\xE7\xE3o em ordem decrescente. Pressione para classificar em ordem crescente.", "pressToSort": "Pressione para classificar." }, "autosizedTextInput": { "charactersRemaining": "{{value}} caracteres restantes" }, "time": { "today": "Hoje \xE0s {{time}}", "yesterday": "Ontem \xE0s {{time}}", "datetime": "{{date}} em {{time}}" }, "progress": { "percentComplete": "{{percent}} conclu\xEDdo" }, "datePicker": { "dateSelected": "{{date}} est\xE1 selecionado.", "noDateSelected": "Nenhuma data selecionada.", "dateBelowMin": "Voc\xEA deve escolher uma data mais recente", "dateAboveMax": "Voc\xEA deve escolher uma data mais antiga", "invalidDate": "Data inv\xE1lida", "today": "Hoje", "clear": "Limpar", "placeholder": { "month": "MM", "day": "DD", "year": "AAAA" }, "nextMonth": "Pr\xF3ximo m\xEAs", "prevMonth": "M\xEAs anterior" }, "dateRange": { "startDate": "Data de in\xEDcio", "endDate": "Data de t\xE9rmino", "endDateBeforeStartDate": "A data de t\xE9rmino deve ser posterior \xE0 data de in\xEDcio.", "startDateAfterEndDate": "A data de in\xEDcio deve ser anterior \xE0 data de t\xE9rmino.", "to": "para" }, "timePicker": { "placeholder": { "hour": "HH", "minute": "MM" } }, "SelectResultList": { "andMore": "\u2026e mais {{count}}.", "loadMore": "Carregar mais" } }, "salesUI": { "UIAvatarAdd": { "ariaLabel": "Adicionar" }, "UIAvatarHoverlay": { "text": "Alterar foto" }, "UIChangeArrow": { "decrease": "Redu\xE7\xE3o de ", "increase": "Aumento de " }, "UICopyInput": { "label": "Texto", "title": "Copiar para a \xE1rea de transfer\xEAncia", "tooltipCopied": "Copiado" }, "UIConfirm": { "defaultConfirm": "Sim", "defaultReject": "N\xE3o" }, "UICloseButton": { "label": "Fechar" }, "UIDateRangePicker": { "rangeType": { "ALL": "Desde sempre", "THIS_DAY": "Hoje", "LAST_DAY": "Ontem", "THIS_WEEK": "Esta semana", "LAST_WEEK": "Semana passada", "THIS_MONTH": "Este m\xEAs", "LAST_MONTH": "M\xEAs passado", "LAST_THIRTY_DAYS": "\xDAltimos 30 dias", "LAST_THREE_MONTHS": "\xDAltimos 3 meses", "THIS_QUARTER": "Este trimestre", "LAST_QUARTER": "\xDAltimo trimestre", "THIS_YEAR": "Este ano", "LAST_YEAR": "Ano passado", "CUSTOM": "Per\xEDodo de tempo personalizado" } }, "UIDropdownSelect": { "placeholder": "Nenhum valor selecionado" }, "UIEditableControls": { "cancel": "Cancelar", "save": "Salvar" }, "UIExpandableText": { "collapseButtonText": "Exibir menos", "expandButtonText": "Exibir mais" }, "UIFileInput": { "defaultChangeLabel": "Alterar arquivo", "defaultSelectLabel": "Escolher arquivo" }, "UIIconRating": { "ariaValueText": "{{value}} de {{maxValue}}" }, "UILink": { "externalTitle": "Link abre em uma nova janela" }, "UILoading": { "title": "Carregando\u2026" }, "UILockBadge": { "title": "Este recurso est\xE1 bloqueado" }, "UIPaginator": { "label": "Pagina\xE7\xE3o", "pageNumber": { "currentIndicator": "Voc\xEA est\xE1 atualmente em ", "description": "P\xE1gina " }, "firstPage": { "label": "Primeiro", "description": "Primeira p\xE1gina" }, "previousPage": { "label": "Voltar", "description": "P\xE1gina anterior" }, "nextPage": { "label": "Pr\xF3ximo", "description": "Pr\xF3xima p\xE1gina" }, "lastPage": { "label": "\xDAltimo", "description": "\xDAltima p\xE1gina" } }, "UIPreviousButton": { "label": "Anterior" }, "UINextButton": { "label": "Pr\xF3ximo" }, "UINumberRating": { "lowRangeLabel": "Discordo fortemente", "highRangeLabel": "Concordo fortemente" }, "UISearchableSelectInput": { "placeholder": "Pesquisar" }, "UISearchInput": { "placeholder": "Pesquisar", "minimumSearchMessage": { "one": "Digite mais 1 caractere", "other": "Digite mais {{count}} caracteres", "many": "Digite mais {{count}} de caracteres" }, "clearButton": "Limpar entrada" }, "UISelect": { "allOptionsSelected": "Todas as op\xE7\xF5es est\xE3o selecionadas", "createOption": "Criar op\xE7\xE3o \u201C{{label}}\u201D", "plusMore": "+ mais {{count}}", "andMore": "\u2026e mais {{count}}.", "loadMore": "Carregar mais", "noResults": "Nenhum resultado encontrado", "placeholder": "Pesquisar", "typeToSearch": "Digite para pesquisar" }, "UITable": { "selectableTableRow": { "toggleSelection": "Alternar sele\xE7\xE3o da linha" } }, "UITabs": { "moreDropdownLabel": "Mais" }, "UITeaseNotification": { "optionsButtonTooltipText": "Mostrar op\xE7\xF5es" }, "UITimePicker": { "placeholder": "Selecione uma hora" }, "UIToggle": { "checkedLabel": "LIGADO", "uncheckedLabel": "DESLIGADO" }, "UITypeahead": { "noMatchesFound": "Nenhuma correspond\xEAncia encontrada", "noOptions": "Nenhum" }, "UIWizard": { "back": "Voltar", "cancel": "Cancelar", "done": "Concluir", "next": "Pr\xF3ximo", "stepCount": "Etapa {{stepNumber}} de {{stepCount}}" }, "XSSTooltip": { "explanation": "Este link foi desativado para sua seguran\xE7a." } } } } };
  result.translationsLoaded = {
  "foundations-components": {
    "pt-br": "static-1.4494"
  }
};
  result.translationsAvailable = {
  "foundations-components": {
    "af": "static-1.4494",
    "ar-eg": "static-1.4494",
    "bg": "static-1.4494",
    "bn": "static-1.4494",
    "ca-es": "static-1.4494",
    "cs": "static-1.4494",
    "da": "static-1.4494",
    "de": "static-1.4494",
    "el": "static-1.4494",
    "en-gb": "static-1.4494",
    "en": "static-1.4494",
    "es-mx": "static-1.4494",
    "es": "static-1.4494",
    "et": "static-1.4494",
    "fi": "static-1.4494",
    "fr-ca": "static-1.4494",
    "fr": "static-1.4494",
    "he-il": "static-1.4494",
    "hi": "static-1.4494",
    "hr": "static-1.4494",
    "hu": "static-1.4494",
    "id": "static-1.4494",
    "it": "static-1.4494",
    "ja": "static-1.4494",
    "ko": "static-1.4494",
    "lt": "static-1.4494",
    "ms": "static-1.4494",
    "nl": "static-1.4494",
    "no": "static-1.4494",
    "pl": "static-1.4494",
    "pt-br": "static-1.4494",
    "pt-pt": "static-1.4494",
    "ro": "static-1.4494",
    "ru": "static-1.4494",
    "sk": "static-1.4494",
    "sl": "static-1.4494",
    "sv": "static-1.4494",
    "th": "static-1.4494",
    "tl": "static-1.4494",
    "tr": "static-1.4494",
    "uk": "static-1.4494",
    "vi": "static-1.4494",
    "zh-cn": "static-1.4494",
    "zh-hk": "static-1.4494",
    "zh-tw": "static-1.4494"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:foundations-components:pt-br', {version: 'static-1.4494'}); }
})();



(function() {
  var result = { translations: { "pt-br": { "placeholder": "texto tempor\xE1rio" } } };
  result.translationsLoaded = {
  "UIComponents": {
    "pt-br": "static-3.6172"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-3.6172",
    "ar-eg": "static-3.6172",
    "bg": "static-3.6172",
    "bn": "static-3.6172",
    "ca-es": "static-3.6172",
    "cs": "static-3.6172",
    "da": "static-3.6172",
    "de": "static-3.6172",
    "el": "static-3.6172",
    "en-gb": "static-3.6172",
    "en": "static-3.6172",
    "es-mx": "static-3.6172",
    "es": "static-3.6172",
    "et": "static-3.6172",
    "fi": "static-3.6172",
    "fr-ca": "static-3.6172",
    "fr": "static-3.6172",
    "he-il": "static-3.6172",
    "hi": "static-3.6172",
    "hr": "static-3.6172",
    "hu": "static-3.6172",
    "id": "static-3.6172",
    "it": "static-3.6172",
    "ja": "static-3.6172",
    "ko": "static-3.6172",
    "lt": "static-3.6172",
    "ms": "static-3.6172",
    "nl": "static-3.6172",
    "no": "static-3.6172",
    "pl": "static-3.6172",
    "pt-br": "static-3.6172",
    "pt-pt": "static-3.6172",
    "ro": "static-3.6172",
    "ru": "static-3.6172",
    "sk": "static-3.6172",
    "sl": "static-3.6172",
    "sv": "static-3.6172",
    "th": "static-3.6172",
    "tl": "static-3.6172",
    "tr": "static-3.6172",
    "uk": "static-3.6172",
    "vi": "static-3.6172",
    "zh-cn": "static-3.6172",
    "zh-hk": "static-3.6172",
    "zh-tw": "static-3.6172"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:pt-br', {version: 'static-3.6172'}); }
})();



(function() {
  var result = { translations: { "pt-br": { "app": { "htmlTitle": "UI de links virais", "welcomeHome": "Bem-vindo(a) ao lar, {{ firstName }}", "yourAppIsReady": "O aplicativo est\xE1 pronto", "aSecondPage": "Uma segunda p\xE1gina para armazenar mais conte\xFAdo", "fillPage_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, "Preencha essa p\xE1gina vazia com ", createElement( options, "Link", props.linkProps, "componentes" ), " em ", createElement( options, "code", null, props.filename ), "." ); }, "viralLinks": { "forms": { "linkCta": "<strong>Crie seus pr\xF3prios formul\xE1rios gratuitos</strong> para gerar leads a partir do seu site." }, "liveChat": { "linkCta": "<strong>Adicione chat ao vivo.</strong> Conecte-se com os visitantes.", "ariaLabel": "Adicione chat ao vivo. Conecte-se com os visitantes. N\xE3o custa nada!" }, "liveChatIntermediate": { "linkCta": "<strong>[Int] Adicione chat ao vivo.</strong> Conecte-se com os visitantes. Gratuitamente.", "ariaLabel": "[Int] Adicione chat ao vivo. Conecte-se com os visitantes. Gratuitamente." }, "meetings": { "linkCta": "<strong>Crie sua p\xE1gina gratuita de agendamento de reuni\xF5es</strong> para agendar reuni\xF5es com mais rapidez." } } } } } };
  result.translationsLoaded = {
  "embedded-viral-link-ui": {
    "pt-br": "static-1.3757"
  }
};
  result.translationsAvailable = {
  "embedded-viral-link-ui": {
    "af": "static-1.3757",
    "ar-eg": "static-1.3757",
    "bg": "static-1.3757",
    "bn": "static-1.3757",
    "ca-es": "static-1.3757",
    "cs": "static-1.3757",
    "da": "static-1.3757",
    "de": "static-1.3757",
    "el": "static-1.3757",
    "en-gb": "static-1.3757",
    "en": "static-1.3757",
    "es-mx": "static-1.3757",
    "es": "static-1.3757",
    "et": "static-1.3757",
    "fi": "static-1.3757",
    "fr-ca": "static-1.3757",
    "fr": "static-1.3757",
    "he-il": "static-1.3757",
    "hi": "static-1.3757",
    "hr": "static-1.3757",
    "hu": "static-1.3757",
    "id": "static-1.3757",
    "it": "static-1.3757",
    "ja": "static-1.3757",
    "ko": "static-1.3757",
    "lt": "static-1.3757",
    "ms": "static-1.3757",
    "nl": "static-1.3757",
    "no": "static-1.3757",
    "pl": "static-1.3757",
    "pt-br": "static-1.3757",
    "pt-pt": "static-1.3757",
    "ro": "static-1.3757",
    "ru": "static-1.3757",
    "sk": "static-1.3757",
    "sl": "static-1.3757",
    "sv": "static-1.3757",
    "th": "static-1.3757",
    "tl": "static-1.3757",
    "tr": "static-1.3757",
    "uk": "static-1.3757",
    "vi": "static-1.3757",
    "zh-cn": "static-1.3757",
    "zh-hk": "static-1.3757",
    "zh-tw": "static-1.3757"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:embedded-viral-link-ui:pt-br', {version: 'static-1.3757'}); }
})();


